import {showErrorNotification, showInfoNotification, showSuccessNotification} from "../../../global/notifications";

// The save/approve/reject flow is identical across every capex request type - only the
// endpoint base URL and the submit action name differ. See general-request.js,
// computer-request.js and vehicle-request.js for the per-type wiring.
export default function createCapexRequestController({baseUrl, submitAction}) {
    const submitRequest = () => {
        return new Promise((resolve, reject) => {
            $.post(`${baseUrl}/${submitAction}`, $('form').serialize(), function (response) {
                if (response.success) {
                    resolve(response.RequestNumber);
                } else {
                    reject(response.message);
                }
            }).fail(function () {
                reject('An error occurred while processing your request.');
            })
        })
    }

    const loadDisplayPage = (requestId) => {
        return new Promise((resolve, reject) => {
            $('form').load(`${baseUrl}/LoadRequestDisplay`, {RequestNumber: requestId}, function (response, textStatus) {
                approvalEvent();
                rejectionEvent();
                if (textStatus === 'error') {
                    reject('Your request was submitted, but loading the request page failed. Please reload the page.');
                    return;
                }
                resolve();
            });
        });
    }

    const checkFormValidation = () => {
        $('.fieldValidationError').removeClass('fieldValidationError');
        const requiredFields = $('[data-required]');
        let pass = true;

        $.each(requiredFields, function (index, ele) {
            const $ele = $(ele);
            if ($ele.val() === "") {
                pass = false;
                if ($ele.hasClass('k-textbox')) {
                    $ele.addClass("fieldValidationError");
                } else {
                    $ele.parent().addClass("fieldValidationError");
                }
            }
        })

        return pass;
    }

    const saveEvent = () => {
        let $submitButton = $('button[type="submit"]');
        $submitButton.unbind('click');
        $submitButton.bind('click', function () {
            $submitButton.prop('disabled', true);
            if (checkFormValidation()) {
                showInfoNotification("Submitting request...");
                submitRequest()
                    // The request has already been created once submitRequest resolves, so a
                    // failure to load the display page must not re-enable the submit button -
                    // that would let the same request be submitted a second time.
                    .then(requestNumber => loadDisplayPage(requestNumber).catch(error => showErrorNotification(error)))
                    .then(_ => $.event.trigger('on:BundleReady'))
                    .then(_ => $.event.trigger('on:AttachmentLoad'))
                    .catch(error => {
                        showErrorNotification(error);
                        $submitButton.prop('disabled', false);
                    });
            } else {
                showErrorNotification("Please complete all required fields.");
                $submitButton.prop('disabled', false);
            }

            return false;
        });
    }

    // Reads the approval form fields into a plain data object. Pure aside from the DOM read
    // itself - no side effects, safe to unit test without mocking $.post.
    const getApprovalFormData = () => ({
        RequestNumber: $('#RequestNumber').val(),
        pin: $('[name="pin"]').val(),
        comment: $('[name="comment"]').val(),
        role: $('[name="role"]').val()
    });

    // Disables/enables the Approve and Reject controls together and shows/hides the busy
    // indicator. Both controls are toggled together so a click on one cannot be followed by a
    // click on the other while the first request is still in flight.
    const setApprovalControlsBusy = (isBusy) => {
        $('button[data-role="approve"], button[data-role="reject"]').prop('disabled', isBusy);
        $('#approval_busy_indicator').toggle(isBusy);
    }

    const approveRequest = () => {
        return new Promise((resolve, reject) => {
            let data = getApprovalFormData();
            $.post(`${baseUrl}/ApproveRequest`, data, function (response) {
                if (response.success) {
                    showSuccessNotification("Request Approved Successfully");
                    resolve(data.RequestNumber);
                } else {
                    reject(response.message);
                }
            }).fail(function () {
                reject('An error occurred while processing your request.');
            });
        });
    }

    const rejectRequest = () => {
        return new Promise((resolve, reject) => {
            let data = getApprovalFormData();
            $.post(`${baseUrl}/RejectRequest`, data, function (response) {
                if (response.success) {
                    showSuccessNotification("Request Rejected Successfully");
                    resolve(data.RequestNumber);
                } else {
                    reject(response.message);
                }
            }).fail(function () {
                reject('An error occurred while processing your request.');
            });
        });
    }

    const loadApprovals = (requestNumber) => {
        return new Promise((resolve, reject) => {
            $('#approval_section').load(`${baseUrl}/LoadRequestApprovals`, {requestNumber: requestNumber}, function (response, textStatus) {
                approvalEvent();
                rejectionEvent();
                if (textStatus === 'error') {
                    reject('Your response was recorded, but refreshing the approvals failed. Please reload the page.');
                    return;
                }
                $.event.trigger('on:BundleReady');
                resolve();
            });
        });
    }

    const approvalEvent = () => {
        const $approvalButton = $('button[data-role="approve"]');
        if ($approvalButton.length) {
            $approvalButton.unbind('click');
            $approvalButton.bind('click', function () {
                setApprovalControlsBusy(true);
                approveRequest()
                    // The approval has already been recorded once approveRequest resolves, so a
                    // failure to refresh the approvals section must not re-enable the controls -
                    // that would allow the same approval to be submitted a second time. Only a
                    // failure of the approval POST itself should let the user retry.
                    .then(requestNumber => loadApprovals(requestNumber).catch(error => showErrorNotification(error)))
                    .catch(error => {
                        setApprovalControlsBusy(false);
                        showErrorNotification(error);
                    });
            });
        }
    }

    const rejectionEvent = () => {
        const $rejectButton = $('button[data-role="reject"]');
        if ($rejectButton.length) {
            $rejectButton.unbind('click');
            $rejectButton.bind('click', function () {
                setApprovalControlsBusy(true);
                rejectRequest()
                    // See the equivalent comment in approvalEvent: the rejection is already
                    // recorded once rejectRequest resolves, so a refresh failure must not
                    // re-enable the controls and allow a second submission.
                    .then(requestNumber => loadApprovals(requestNumber).catch(error => showErrorNotification(error)))
                    .catch(error => {
                        setApprovalControlsBusy(false);
                        showErrorNotification(error);
                    });
            });
        }
    }

    return {
        init: () => {
            saveEvent();
            approvalEvent();
            rejectionEvent();
        },
        getApprovalFormData,
        setApprovalControlsBusy,
        approveRequest,
        rejectRequest,
        approvalEvent,
        rejectionEvent,
    };
}
